import * as types from '../types'

/**
 * 活动详情数据
 * @type {Object}
 */
const state = {
    info: {
        activity: {
            name: '',
        },
        detail: [],
        skus: [],
        thumb: ''
    }
}

const getters = {

}

const mutations = {
    [types.INIT_ACTIVITY_DETAIL] (state, params) {
        state.info = params
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/activity.js